import icsChromelyRequest from '@icreate/ics-chromely-js-sdk'
// import { AxiosInstance } from 'axios'
import { escapeSpecialCharacters } from './utils'

export default class IndexExamine {
  private static OperateEx(url: string, data?: any): Promise<any> {
    // let opts =
    return icsChromelyRequest.function({
      url: `LocalIndex/${url}`,
      method: 'GET',
      data
    })
  }

  /**
   * 传过来的axios实例
   */
  private static Request: any

  public static use({ request }: { request: any }) {
    this.Request = request
  }

  // public static isChromely = icsChromelyRequest.isChromely

  /**
   *
   * @param indexId: 索引id
   * @param category：分类
   * @param keys：关键字
   * @returns 成功：{code: 200, data, message: 'ok'}
   */
  public static query(
    indexId: string,
    category: string | Array<string>,
    keys: string
  ): Promise<any> {
    return this.OperateEx('Query', { indexId, category, keys })
  }

  /**
   *
   * @param indexId: 索引id
   * @param category：分类
   * @param keys：关键字
   * @param like：模糊匹配字段
   * @param exact：精确匹配字段和值
   * @returns 成功：{code: 200, data, message: 'ok'}
   */
  public static queryByServer(
    indexId: string,
    category: string | Array<string>,
    keys: string,
    like: Array<string>,
    exact: object
  ): Promise<any> {
    return this.Request({
      url: 'system/index/query',
      method: 'post',
      data: {
        index: indexId,
        category: Array.isArray(category) ? category.join(',') : category,
        keys,
        like,
        exact
      }
    }).then((res: any) => {
      return Promise.resolve(res.data)
    })
  }

  /**
   *
   * @param indexId: 索引id
   * @param pageIndex：page索引
   * @param pageSize：page尺寸
   * @param category：分类
   * @param keys：关键字
   * @returns 成功：{code: 200, data, message: 'ok'}
   */
  public static page(
    indexId: string,
    pageIndex: number,
    pageSize: number,
    category: string,
    keys: string
  ): Promise<any> {
    return this.OperateEx('Page', {
      indexId,
      pageIndex,
      pageSize,
      category,
      keys
    })
  }

  /**
   *
   * @param indexId: 索引id
   * @param pageIndex：page索引
   * @param pageSize：page尺寸
   * @param category：分类
   * @param keys：关键字
   * @param like：模糊匹配字段
   * @param exact：精确匹配字段和值
   * @returns 成功：{code: 200, data, message: 'ok'}
   */
  public static pageByServer(
    indexId: string,
    pageIndex: number,
    pageSize: number,
    category: string,
    keys: string,
    like: Array<string>,
    exact: object
  ): Promise<any> {
    return this.Request({
      url: 'system/index/page',
      method: 'post',
      data: {
        index: indexId,
        pageIndex,
        pageSize,
        category: Array.isArray(category) ? category.join(',') : category,
        keys,
        like,
        exact
      }
    }).then((res: any) => {
      return Promise.resolve(res.data)
    })
  }
}
